import React from 'react';
import './CartItem.css';
import { BsTrashFill} from "react-icons/bs";

const CartItem = (props) => {
    const { id ,img, name } = props.selectedProduct;
    const {removeItem} = props;
    return (
        <div className='cartItem'>
            <div>
                <img className="mx-4" src={img} alt="" />
            </div>
            <p className="ml-4"> {name} </p>
            <button className='delete-button' onClick={() => removeItem(id)}>
                <div className=" flex justify-center items-center text-2xl text-black">
                    < BsTrashFill></BsTrashFill>
                </div>
            </button>
        </div>
    );
};

export default CartItem;